import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, shareReplay } from 'rxjs';
import { DictionaryField } from '../../../../gk-dynamic-list/services/dictionary/dictionary.model';
import { PortalId } from '../../../../utils/portal-id/portal-id.model';
import { RequestModelFromApi } from './request-mode.model';

@Injectable()
export class RequestModeService {
  private requestModesMap = new Map<PortalId, Observable<DictionaryField[]>>();

  constructor(private httpClient: HttpClient) {}

  getModes(portalId: PortalId, url?: string): Observable<DictionaryField[]> {
    let requestModes$ = this.requestModesMap.get(portalId);

    if (!requestModes$) {
      requestModes$ = this.httpClient
        .get<
          RequestModelFromApi[]
        >(url || `/api/system/web/portal/${portalId}/tryb`)
        .pipe(
          map((modes) =>
            modes.map(
              (mode) => new DictionaryField(mode.TrybId, mode.TrybName),
            ),
          ),
          shareReplay(1),
        );
      this.requestModesMap.set(portalId, requestModes$);
    }

    return requestModes$;
  }
}
